/**
 * Created by will on 19/10/18.
 */

export class HubMessage {
    uid: number;
    created: string;
    hubid: string;
    from: string;
    subject: string;
    body: string;
    time_sent: string;
    time_read: string;
    response: number;
    mail_type: number;
    positive: string;
    negative: string;
}
